module.exports = __webpack_public_path__ + "img/metamask-logo.1866566c.svg";